var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolbarItemContainer',{attrs:{"iconFile":_vm.handleIcon(),"title":_vm.handleTitle(),"needDialog":false,"iconWidth":_vm.isUniFrameWork ? '32px' : '21px',"iconHeight":_vm.isUniFrameWork
      ? _vm.props.videoSourceType === 'album'
        ? '20px'
        : '25px'
      : '18px'},on:{"onIconClick":_vm.onIconClick}},[_c('div',{class:['video-upload', !_vm.isPC && 'video-upload-h5']},[_c('input',{ref:"inputRef",attrs:{"title":"视频","type":"file","data-type":"video","accept":"video/*"},on:{"change":_vm.sendVideoInWeb}})])])}
var staticRenderFns = []

export { render, staticRenderFns }